import React from "react";
import Grid from "@material-ui/core/Grid";
import { useInvAF } from "../../../../St/Reviews/UseStyle";
import { getTotalAmount } from "../../../../utils/utils";
import tafqeet from "../../../../utils/tafqeet";
import { styleFooterNotesAr, stylePadding } from "../../ShareFunctionsPrint";

const InvTotalsEn = (porps) => {
    const { locInv, inv, sta } = porps;
    const clas = useInvAF();
    const totVAT = sta.tot.amountOfVat;
    const totNet = sta.tot.tot_net;
    const totBef = getTotalAmount(sta.tot) - sta.tot?.discount;

    const totVatN = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(totVAT);

    const totNetN = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(totNet);

    const totBefN = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(totBef);

    return (
        <Grid item container style={stylePadding} >
            <Grid item container xs={12} style={{ fontFamily: "Amiri-Regular", }} >
                <Grid item xs={8} className={clas.BdyborBtRTOPTotal} >
                    <div style={{ fontWeight: "bold", padding: 3 }}>{"Net Amount"} {"الصافي"}</div>
                </Grid>
                <Grid item xs={4} className={clas.BdyborBtRTOPTotal} style={{ textAlign: "center" }}>
                    <div style={{ fontWeight: "bold", padding: 3 }}>{"SAR   "}{totBefN}</div>
                </Grid>
                <Grid item xs={8} className={clas.BdyborBtRTOPTotal2}>
                    <div style={{ fontWeight: "bold", padding: 3 }}>{"VAT 15%"} {"ضريبة القيمة المضافة"}</div>
                </Grid>
                <Grid item xs={4} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
                    <div style={{ fontWeight: "bold", padding: 3 }}>{"SAR   "}{totVatN} </div>
                </Grid>
                <Grid item xs={8} className={clas.BdyborBtRTOPTotal2}>
                    <div style={{ fontWeight: "bold", padding: 3 }}>{"Grand Total"} {"الإجمالي"}</div>
                </Grid>
                <Grid item xs={4} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
                    <div style={{ fontWeight: "bold", padding: 3 }}>{"SAR   "}{totNetN} </div>
                </Grid>
                <Grid item xs={12} className={clas.BdyborBtRTOPTotal2}>
                    <div style={{ fontWeight: "bold", padding: 3 }}>{tafqeet(sta.tot.tot_net, "SAR")} </div>
                </Grid>
            </Grid>
            <Grid item container xs={12} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.5rem", }}>
                <Grid
                    item
                    container
                    xs={12}
                    style={styleFooterNotesAr}
                >
                    {inv.notes}
                </Grid>

            </Grid>
            {locInv.ProcTypeInvProc != "03" && locInv.ProcTypeInvProc != "04" ? (
                <Grid item xs={12} container className={clas.footerB} >
                    <Grid item xs={4} style={{ fontFamily: "Amiri-Regular", fontWeight: "bold", paddingTop: "1rem", textAlign: "center" }}>
                        {" "}
                        {"SALES"}
                    </Grid>
                    <Grid item xs={4} style={{ fontFamily: "Amiri-Regular", fontWeight: "bold", paddingTop: "1rem", textAlign: "center" }}>
                        {"FINANCIAL"}
                    </Grid>

                    <Grid item xs={4} style={{ fontFamily: "Amiri-Regular", fontWeight: "bold", paddingTop: "1rem", textAlign: "center" }}>
                        {"CUSTOMER"}
                    </Grid>
                </Grid>
            ) : null}
        </Grid>
    );
};

export default InvTotalsEn;
